import React from 'react';
import SurveyItem from '../../../util/SurveyItem';
import {
  withIsReadOnly,
  WithIsReadOnlyInjectedProps,
  withSubjectId,
  WithSubjectIdInjectedProps,
} from '../../Contexts';
import withCheckForEnablement, {
  WithCheckForEnablementInjectedProps,
} from '../../hoc/withCheckForEnablement';
import withValidation, {
  WithValidationInjectedProps,
} from '../../hoc/withValidation';
import { Text } from '@lifeomic/chroma-react/components/Text';
import SurveyItemContainer from '../../SurveyItemContainer';
import SurveyField from '../../SurveyField';
import clsx from 'clsx';
import FieldComponent from './FieldComponent';
import useStyles from './styles';

export interface GenomicsReportOwnProps {
  surveyItem: SurveyItem;
}

export type GenomicsReportProps = GenomicsReportOwnProps &
  WithCheckForEnablementInjectedProps &
  WithIsReadOnlyInjectedProps &
  WithValidationInjectedProps &
  WithSubjectIdInjectedProps;

const GenomicsReport = (props: GenomicsReportProps) => {
  const classes = useStyles({});
  const {
    error,
    isReadOnly,
    surveyItem,
    shouldShowError,
    validate,
    subjectId,
    isEnabled,
  } = props;

  const QuestionText = () => {
    const { prefix, text, label, required } = surveyItem;

    let headerText = '';
    if (prefix) {
      headerText = `${required ? '* ' : ''}(${prefix}) ${text}`;
    } else {
      headerText = label;
    }

    if (!headerText) return null;

    return (
      <Text
        size="body"
        className={clsx(
          classes.labelText,
          shouldShowError && classes.errorLabel,
        )}
      >
        {headerText}
      </Text>
    );
  };

  if (!isEnabled) return null;

  return (
    <SurveyItemContainer surveyItem={surveyItem}>
      <div className={classes.root}>
        <QuestionText />
        <SurveyField
          responseAnswerType={surveyItem.responseValueType}
          name={surveyItem.link}
          surveyItem={surveyItem}
          component={FieldComponent}
          classes={classes}
          isReadOnly={isReadOnly}
          validate={validate}
          error={error}
          shouldShowError={shouldShowError}
          subjectId={subjectId}
        />
      </div>
    </SurveyItemContainer>
  );
};

export default withCheckForEnablement(
  withIsReadOnly(withValidation(withSubjectId(GenomicsReport))),
);
